import { useSelector } from 'react-redux';

export default function PayTypeShow({id}) {
    const { pos } = useSelector((state) => ({
        pos: state.setting.pos,
    }));
    return (
        <>
            {
                pos &&
                <span className={+id === 0 ? 'text-primary' : +id === -1 ? 'text-danger' : 'text-success'}>
                    {+id === 0 ? 'نقدی' : +id === -1 ? 'نامشخص' : pos.find(i => +i.id === +id).name}
                </span>
            }
        </>
    );
}